import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

/* Pages & Components */
import { CalendarMainPageComponent } from "./pages/main/calendar-main-page/calendar-main-page.component";
import { FullCalendarComponentComponent } from "./components/calendar-fullCalendar/full-calendar-component/full-calendar-component.component";
import { EventDetailsComponent } from "./components/event-details/event-details.component";
import { ModalAddSessionv2Component } from "./components/modal-add-sessionv2/modal-add-sessionv2.component";

/* External Modules */
import { FullCalendarModule } from "@fullcalendar/angular";
import {
  NgbCollapseModule,
  NgbDatepickerModule,
  NgbTimepickerModule,
  NgbDatepickerI18n,
} from "@ng-bootstrap/ng-bootstrap";

/* Shared */
import { SharedModule } from "../shared/shared.module";
import { MaterialModule } from "../material.module";

/* Services */
import { AuthenticationService } from "../auth/services/authentication.service";
import {
  CustomDatepickerI18n,
  I18n,
} from "../shared/utils/spanish.calentar.service";

@NgModule({
  declarations: [
    CalendarMainPageComponent,
    FullCalendarComponentComponent,
    EventDetailsComponent,
    ModalAddSessionv2Component,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FullCalendarModule,
    NgbCollapseModule,
    NgbDatepickerModule,
    NgbTimepickerModule,
    SharedModule,
    MaterialModule,
  ],
  providers: [
    AuthenticationService,
    I18n,
    { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
  ],
  exports: [ModalAddSessionv2Component],
})
export class CalendarModule {}
